module.exports = __webpack_public_path__ + "static/img/xclogo.be34845e.png";